import { render } from "./CIS-Resource-Spotlight.vue?vue&type=template&id=3a05441e&scoped=true"
import script from "./CIS-Resource-Spotlight.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Spotlight.vue?vue&type=script&lang=js"

import "./CIS-Resource-Spotlight.vue?vue&type=style&index=0&id=3a05441e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a05441e"]])

export default __exports__